import base from "./base.service";

const getCountries = payload => base.get('/masters/countryList');
const getHomePageDetails =()=>base.get('/masters/home')
export const masterService = {
    getCountries,
    getHomePageDetails
}